Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);
var _pathHelpers=require("./path-helpers");var _pathHelpers2=_interopRequireDefault(_pathHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Point=function(_React$Component){_inherits(Point,_React$Component);function Point(){_classCallCheck(this,Point);return _possibleConstructorReturn(this,(Point.__proto__||Object.getPrototypeOf(Point)).apply(this,arguments));}_createClass(Point,[{key:"getPath",value:function getPath(

























props){var
datum=props.datum,active=props.active,x=props.x,y=props.y;
var pathFunctions={
circle:_pathHelpers2.default.circle,
square:_pathHelpers2.default.square,
diamond:_pathHelpers2.default.diamond,
triangleDown:_pathHelpers2.default.triangleDown,
triangleUp:_pathHelpers2.default.triangleUp,
plus:_pathHelpers2.default.plus,
star:_pathHelpers2.default.star};

var symbol=_helpers2.default.evaluateProp(props.symbol,datum,active);
var size=_helpers2.default.evaluateProp(props.size,datum,active);
return pathFunctions[symbol].call(null,x,y,size);
}},{key:"renderPoint",value:function renderPoint(


path,style,events){var _props=
this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
return(
_react2.default.createElement("path",_extends({},
events,{
d:path,
className:className,
role:role||"presentation",
shapeRendering:shapeRendering||"auto",
style:style})));


}},{key:"render",value:function render()

{var _props2=
this.props,style=_props2.style,datum=_props2.datum,active=_props2.active,events=_props2.events;
var evaluatedStyle=_helpers2.default.evaluateStyle(style,datum,active);
return this.renderPoint(this.getPath(this.props),evaluatedStyle,events);
}}]);return Point;}(_react2.default.Component);Point.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,datum:_react.PropTypes.object,data:_react.PropTypes.array,events:_react.PropTypes.object,index:_react.PropTypes.number,role:_react.PropTypes.string,size:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.func]),shapeRendering:_react2.default.PropTypes.string,symbol:_react.PropTypes.oneOfType([_react.PropTypes.oneOf(["circle","diamond","plus","square","star","triangleDown","triangleUp"]),_react.PropTypes.func]),scale:_react.PropTypes.object,style:_react.PropTypes.object,x:_react.PropTypes.number,y:_react.PropTypes.number};exports.default=Point;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/point.js
// module id = 1271
// module chunks = 0 1